/* eslint-disable */
import React from 'react';
import ReactDOM from 'react-dom/client';
import {QueryClient, QueryClientProvider} from 'react-query';
import {GoogleOAuthProvider} from '@react-oauth/google';
import * as Sentry from '@sentry/react';
import {ReactQueryDevtools} from 'react-query/devtools';
import ConfigProvider from './app/common/providers/ConfigProvider';
import DataProvider from './app/common/providers/DataProvider';
import {I18nProvider} from './app/common/providers/I18nProvider';
import {AuthProvider} from './app/modules/auth';
import AppRoutes from './app/routing/AppRoutes';
import './assets/styles/globals.scss';
import './assets/styles/root.scss';
import {LayoutProvider} from './app/common/components/layout/LayoutProvider';
import {NavbarActionProvider} from './app/common/providers/NavActionProvider';
// import LandscapeBlocker from './landscapemode/LandscapeBlocker';

// Sentry.init({
// 	dsn: 'https://6349ec14355cb736942d5329640bf4df@o4505143411671040.ingest.sentry.io/4505617962631168',
// 	integrations: [
// 		new Sentry.BrowserTracing({
// 			// Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
// 			tracePropagationTargets: ['localhost', 'https:yourserver.io/api/'],
// 		}),
// 		new Sentry.Replay(),
// 	],
// 	// Performance Monitoring
// 	tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
// 	// Session Replay
// 	replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
// 	replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
// });

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
const queryClient = new QueryClient();
// const goggleClientId = process.env.GOOGLE_AUTH_CLIENT_ID ?? '';
const goggleClientId = '969529068703-3orvgl3j4jisjbdln5akis27bao3snmg.apps.googleusercontent.com';

root.render(
	<React.StrictMode>
		<ConfigProvider>
			{/* <LayoutProvider> */}
			<GoogleOAuthProvider clientId={goggleClientId}>
				<QueryClientProvider client={queryClient}>
					<I18nProvider>
						<AuthProvider>
							<DataProvider>
								<NavbarActionProvider>
									{/* <LandscapeBlocker /> */}
									<AppRoutes />
								</NavbarActionProvider>
							</DataProvider>
						</AuthProvider>
					</I18nProvider>
					<ReactQueryDevtools initialIsOpen={false} />
				</QueryClientProvider>
			</GoogleOAuthProvider>
			{/* </LayoutProvider> */}
		</ConfigProvider>{' '}
	</React.StrictMode>,
);
